import { urlify } from "#scripts/general_functions.js";

export const checksum = (s) => {
	let chk = 0x111111;
	const len = s.length;
	for (let i = 0; i < len; i++) {
		chk += s.charCodeAt(i) * (i + 1);
	}
	return (chk & 0xffffffff).toString(16);
};

export const generateCompactSeed = () => {
	const rawSeed = Date.now().toString() + Math.random().toString(36).substring(2);
	let chk = 0x111111;
	for (let i = 0; i < rawSeed.length; i++) {
		chk += rawSeed.charCodeAt(i) * (i + 1);
	}
	return (chk & 0xffffffff).toString(16); // .padStart(8, '0').slice(0, 8);
}


export const setAccordian = (content = false) => {
	// Define the event handler function
	function handleAccordionClick (event) {
		const button = event.target.closest("button.accordian-titlebutton");
		if (button) {
			event.stopPropagation();

			// Toggle 'accordian-titlebutton--open' class on the clicked button
			button.classList.toggle("accordian-titlebutton--open");

			// Toggle 'accordian-content--open' class on the target element
			const target = document.querySelector(button.getAttribute("data-target"));
			if (target) {
				target.classList.toggle("accordian-content--open");
			}

			// Toggle 'accordian--open' class on the parent element
			const parent = document.querySelector(button.getAttribute("data-parent"));
			if (parent) {
				parent.classList.toggle("accordian--open");
			}

			// Update 'aria-expanded' attribute
			button.setAttribute("aria-expanded", button.classList.contains("accordian-titlebutton--open"));
		}
	}

	if (!document.body.hasAccordianEventListener) {
		// Remove any existing event listeners (if needed)
		document.body.removeEventListener("click", handleAccordionClick);
		// Attach the event listener to the body element
		document.body.addEventListener("click", handleAccordionClick);
		document.body.hasAccordianEventListener = true;
	}

	if (content) {
		const tempWrapper = document.createElement("div");
		tempWrapper.className = "temp-wrapper";
		tempWrapper.innerHTML = content;

		const accordians = tempWrapper.querySelectorAll(".accordian");
		for (let accordian of accordians) {
			const title = accordian.querySelector(".accordian-title");
			const accordianContent = accordian.querySelector(".accordian-content");
			const titletext = title?.textContent.trim() ?? "trekkspill";
			const id = urlify(titletext?.replace(/[^a-zA-Z0-9-_]/g, ""));
			let chkSum;

			if (accordianContent?.innerHTML.trim()) {
				chkSum = checksum(accordianContent.innerHTML);
			} else {
				chkSum = generateCompactSeed();
			}

			const titleid = `acc-boxheader-${id}_${chkSum}`;
			const contentid = `acc-boxcontnt-${id}_${chkSum}`;
			const boxid = `box-${id}_${chkSum}`;

			accordian.id = boxid;
			if (title) {
				title.classList.add("accordian-title");
				title.id = titleid;
				title.removeAttribute("onblur");
				title.removeAttribute("onfocus");
				title.removeAttribute("onclick");
				title.innerHTML = `
						<button class="accordian-titlebutton" type="button" 
							data-toggle="collapse" 
							data-target="#${contentid}" 
							data-parent="#${boxid}" 
							aria-expanded="false" 
							aria-controls="${contentid}">
								${titletext}
						</button>`;
			}
			if (accordianContent) {
				accordianContent.id = contentid;
				accordianContent.removeAttribute("onblur");
				accordianContent.removeAttribute("onfocus");
				accordianContent.removeAttribute("onclick");
				accordianContent.setAttribute("data-scrolltoaction", "openaccordian");
				accordianContent.setAttribute("aria-labelledby", titleid);
				accordianContent.setAttribute("data-parent", `#${boxid}`);
			}
		}
		return tempWrapper.innerHTML;
	}
	return "";
};

export const openAccordian = (elm) => {
	// data-scrolltoaction="openaccordian" sett på container som har id.
	const accordianElm = document.getElementById(elm);
	const buttonElm = accordianElm.querySelector(".accordian-titlebutton");
	let contentElm = accordianElm.querySelector(".accordian-content");
	if (!contentElm) {
		contentElm = accordianElm.parentNode.querySelector(".accordian-content");
	}

	accordianElm?.classList.toggle("accordian--open");
	buttonElm?.classList.toggle("accordian-titlebutton--open");
	contentElm?.classList.toggle("accordian-content--open");
};
